import { toNumber } from "./../../helper/number.mjs";
import { ERROR_VALUE } from "./../../error.mjs";
export var SYMBOL = '^';
export default function func(exp1, exp2) {
  var result = Math.pow(toNumber(exp1), toNumber(exp2));

  if (isNaN(result)) {
    throw Error(ERROR_VALUE);
  }

  return result;
}
func.SYMBOL = SYMBOL;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_hot-formula-parser@4.0.0@hot-formula-parser/evaluate-by-operator/operator/power.mjs
// module id = null
// module chunks = 